<template>
  <div>
    <vx-card>
      <data-table
        :row-data="rowData"
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        exportable
        pagination
        @update:cell-value="submitItem"
      >
        <template #actions>
          <input
            ref="fileInput"
            accept="text/csv"
            class="file-input"
            type="file"
            @change="onFileChange"
            @click="onFileInputClick"
          />
          <vx-tooltip
            title="商品原価・出品者カテゴリの一括登録"
            position="top"
            min-width="250px"
          >
            <template #text>
              <p class="px-2 whitespace-pre-line">
                CSVファイルによって商品原価・出品者カテゴリを一括で登録／変更することができます。
                <a
                  href="https://www.notion.so/ubun/c61f135dc0ff4c39a8b271400012366e"
                  target="_blank"
                >
                  詳細はこちら
                </a>
              </p>
            </template>
            <vs-button
              type="border"
              class="mb-4 md:mb-0 mr-2"
              @click="activateFileInput"
            >
              CSVアップロード
            </vs-button>
          </vx-tooltip>
        </template>
      </data-table>
    </vx-card>
    <vs-popup
      v-model:active="popupUploadComplete"
      title="CSVアップロード"
    >
      <p class="mb-4 mt-5">
        アップロードが完了しました。
      </p>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from '@/components/table/DataTable'
import { escapeHtml } from '@/utils'

export default {
  name: 'Product',
  components: {
    DataTable
  },
  data () {
    return {
      popupUploadComplete: false,
      errorMessage: '',
      updateData: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        { headerName: 'ASIN（親）', field: 'parentAsin' },
        { headerName: 'ASIN（子）', field: 'asin' },
        { headerName: '画像', field: 'smallImage', width: 100, cellRenderer: this.imageRenderer },
        { headerName: '商品名', field: 'title' },
        { headerName: 'カテゴリー', field: 'categoryName'},
        { headerName: 'サブカテゴリー', field: 'subcategoryName' },
        { headerName: 'ブランド', field: 'brand' },
        { headerName: 'カテゴリーSR', field: 'categorySr' },
        { headerName: 'サブカテゴリーSR', field: 'subcategorySr' },
        { headerName: '出品者カテゴリー',
          field: 'sellerCategory',
          editable: true,
          cellRenderer (params) {
            const value = params.value === null ? '' : params.value
            return `<span class="cell-unselected cell-selected">${ escapeHtml(value) }</span>`
          }
        },
        { headerName: '出品者カテゴリー2', field: 'sellerCategory2' },
        { headerName: '出品者カテゴリー3', field: 'sellerCategory3' },
        { headerName: '出品者カテゴリー4', field: 'sellerCategory4' },
        { headerName: '出品者カテゴリー5', field: 'sellerCategory5' },
        { headerName: '商品原価',
          field: 'cost',
          editable: true,
          cellRenderer (params) {
            let v = ''
            if (typeof params.value === 'number') {
              v = `\xA5${params.value.toLocaleString()}`
            }
            return `<span class="cell-unselected cell-selected">${ v }</span>`
          }
        },
        { headerName: 'サブ画像1', field: 'itemImage1', width: 100, cellRenderer: this.imageRenderer },
        { headerName: 'サブ画像2', field: 'itemImage2', width: 100, cellRenderer: this.imageRenderer },
        { headerName: 'サブ画像3', field: 'itemImage3', width: 100, cellRenderer: this.imageRenderer },
        { headerName: 'サブ画像4', field: 'itemImage4', width: 100, cellRenderer: this.imageRenderer },
        { headerName: 'サブ画像5', field: 'itemImage5', width: 100, cellRenderer: this.imageRenderer },
        { headerName: 'サブ画像6', field: 'itemImage6', width: 100, cellRenderer: this.imageRenderer },
        { headerName: 'サブ画像7', field: 'itemImage7', width: 100, cellRenderer: this.imageRenderer },
        { headerName: 'サブ画像8', field: 'itemImage8', width: 100, cellRenderer: this.imageRenderer },
        { headerName: 'サブ画像9', field: 'itemImage9', width: 100, cellRenderer: this.imageRenderer }
      ]
    }
  },
  computed: {
    ...mapState('product', ['products']),
    rowData: {
      get () {
        return JSON.parse(JSON.stringify(this.products))
      }
    }
  },
  async mounted () {
    try {
      await this.listProducts()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('product', ['listProducts', 'updateProduct', 'uploadProducts']),
    async submitItem (payload) {
      try {
        await this.updateProduct(payload.data)
      } catch (e) {
        console.log(e)
      }
    },
    imageRenderer (params) {
      if (!params.value) return
      return `<img src="${  params.value  }" width="50" height="auto" style="padding:10px; box-sizing:border-box;">`
    },
    gridCurrencyFormatter (params) {
      let v = ''
      if (typeof params.value === 'number') {
        v = `\xA5${params.value.toLocaleString()}`
      }
      return v
    },
    activateFileInput () {
      this.$refs.fileInput.click()
    },
    onFileInputClick () {
      // 同じファイル名を選択したときにchangeイベントが発火しないことを防ぐための処置
      // https://stackoverflow.com/questions/12030686/html-input-file-selection-event-not-firing-upon-selecting-the-same-file
      this.$refs.fileInput.value = null
    },
    async onFileChange (event) {
      const files = event.target.files || event.dataTransfer.files
      if (files.length > 0) {
        const data = {
          file: files[0]
        }
        try {
          await this.uploadProducts(data)
          this.popupUploadComplete = true
          window.setTimeout(() => {
            this.popupUploadComplete = false
          }, 2000)
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
}

</script>

<style>
.holamundo .vs-popup {
  width: 700px;
}
.file-input {
  position: absolute;
  left: -99999px;
}
.cell-unselected {
  border: 1px solid darkgray;
  border-radius: 5px;
  padding: .3em .5em;
  display: inline-block;
  line-height: 2;
  min-width: 80px;
  min-height: 38px;
  margin: 4px auto;
}
.ag-cell-focus .cell-selected {
  border: none;
  padding: unset;
}
</style>
